import { connect } from 'react-redux';
import { closeC2CModal } from '../../../store/actions/C2CModal.action'
import { IStateType } from '../../../store/models/root.interface';
import C2CModal, { MapStateToPropsType, MapDispatchToPropsType } from '../C2CModal'

const mapStateToProps = (state: IStateType) => ({
    C2CModal: state.C2CModal,
});

const mapDispatchToProps = (dispatch: any) => ({
    closeC2CModal: () => dispatch(closeC2CModal()),
});

export default connect<MapStateToPropsType, MapDispatchToPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(C2CModal);
